import styled, { keyframes } from 'styled-components';

import { CloseButton } from '../../sharedStyledComponents/Components';
import ButtonGoActive from '../../buttons/ButtonGoActive';

const skinColorMap = {
  bird: 'linear-gradient(to bottom, #256a8d, #9e625b)',
  cat: 'linear-gradient(to bottom, #256a8d, #3c9989)',
  beast: 'linear-gradient(to bottom, #256a8d, #5e3f78)',
};

export const ModalPanel = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 472px;
  height: 330px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CuriosoIcon = styled.div`
  position: relative;
  width: 160px;
  height: 160px;
  margin-left: 5px;
  flex-shrink: 0;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  height: 120px;
  width: 100%;
  margin: 90px 0 0;
  padding: 0 30px 0 50px;
`;

export const CuriosoCircle = styled.div`
  position: absolute;
  top: 30px;
  left: 30px;
  width: 95px;
  height: 95px;
  border-radius: 50%;
  background-color: #312921;
  background-image: ${({ curiosoSkin }) => skinColorMap[curiosoSkin]};
  animation: smoothPopup 0.5s ease-out forwards;
  transform: scale(0);
  animation-delay: 100ms;
  @keyframes smoothPopup {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

export const Background = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export const TopIcon = styled.img`
  position: absolute;
  width: 124;
  height: 40;
  transform: translate(-50%, 50%);
  top: 0;
  left: 50%;
`;

export const ModalText = styled.h2`
  margin: 0 auto 0 0;
  width: 235;
  font-family: 'Quicksand Medium';
  font-size: 27;
  font-style: normal;
  letter-spacing: normal;
  color: #ffffff;
  overflow-wrap: break-word;
`;

export const Burst = styled.img`
  width: 160;
  height: 160;
  animation: rotation 2s ease-out forwards;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(45deg);
    }
  }
`;

const curiosoPopup = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
`;

export const CuriosoContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 150px;
  height: 150px;
  transform: translate(-50%, -50%);
  animation: ${curiosoPopup} 0.5s ease-out;
`;

export const Decoline = styled.img`
  position: relative;
  width: 352;
  height: 15;
`;

export const ChapterNumber = styled.p`
  width: 120;
  height: 28;
  font-family: 'Open Sans Bold';
  font-size: 21;
  text-align: center;
  color: #ffffff;
  margin: 15px 0 0 0;
`;

export const CloseModalButton = styled(CloseButton)`
  z-index: 1;
  position: absolute;
  transform: translate(50%, -50%);
  top: 35px;
  right: 8px;
`;

export const GoButton = styled(ButtonGoActive)`
  position: absolute;
  transform: translate(-50%, 50%);
  bottom: 10px;
  left: 50%;
`;
